export default "__VITE_ASSET__851dec2d__"